export class PostSlider {

    static init() {
        PostSlider.postSlider();
    }

    static postSlider()
    {
        var $navs = $('.post-paginator');

        if($navs.length > 0) {

            $(document).on('scroll', function () {
                var postHeightOffset = $('.single-post .post-content').offset().top + $('.single-post .post-content').height();
                var scrollOffset = $(document).scrollTop();
                var threshold = (postHeightOffset - 2000) * 0.75;

                if (scrollOffset > threshold) {
                    $navs.addClass('show');
                }
            })
        }
    }
}